<template>
  <div class="page-header">
    <div class="container">
      <h2
        :class="[
          'h2-title text-uppercase',
          {
            'h2-title--light': textLight,
          },
        ]"
      >
        <div>{{ title }}</div>
        <div v-if="secondTitle">{{ secondTitle }}</div>
      </h2>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: 'Default page title',
    },
    secondTitle: {
      type: String,
    },
    textLight: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
